import { createCRUDHook } from './createCRUDHook';
import { UserWidgetDto, FilterOptionModel } from 'utils/models';
import { CancelToken } from 'axios';
import { FILTERED_ENTITIES, USER_WIDGET } from './apiEndPoints';
import { prepareQueryParams } from 'utils';

interface UserWidgetCustomOperations {
  getUserWidgetDataByFE: (
    filteredEntities: FilterOptionModel,
    cancelToken?: CancelToken
  ) => Promise<UserWidgetDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  UserWidgetDto,
  UserWidgetDto[],
  UserWidgetCustomOperations
>({
  entityName: 'UserWidget',
  endpoint: USER_WIDGET,

  customOperations: (auth) => ({
    getUserWidgetDataByFE: async (
      filteredEntities: FilterOptionModel,
      cancelToken?: CancelToken
    ): Promise<UserWidgetDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          USER_WIDGET +
            FILTERED_ENTITIES +
            `?${prepareQueryParams(filteredEntities)}`,
          cancelToken
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const UserWidgetContext = Context;
export const useUserWidgetManager = useManager;
export const useUserWidget = useConsumer;
